















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class SideModal extends Vue {

  @Prop({ default: false, type: Boolean })
  private readonly open!: boolean;

  @Prop({ default: '50%' })
  private readonly width!: number | string;

  @Prop({ default: 500, type: Number })
  private readonly zIndex!: number;

  private togglePageOverflow(hidden: boolean) {
    const $html = document.querySelector('html');

    if ($html) {
      $html.style.overflowY = hidden ? 'hidden' : 'scroll';
    }
  }

  @Watch('open', { immediate: true })
  private onOpenChange(open: boolean) {
    this.togglePageOverflow(open);
  }

  destroyed() {
    this.togglePageOverflow(false);
  }

}
